/**
 * 目次 (TOC) 生成
 *
 * 旧 Concrete の `<div class="bt_toc ..." data-toc="<selector>"></div>` 要素を見つけ、
 * data-toc が指す CSS セレクタ (例: "h2", ".extra-heading") にマッチする見出しを集めて
 * <ul><li><a> を流し込む。
 *
 * anchor 解決優先度:
 *   1. 見出し内の <a id="..."> または <a name="...">  (`.extra-heading > a` パターン)
 *   2. 祖先の .q-wrap.id (FAQ パターン)
 *   3. 見出し自身の id
 *   4. 自動生成 `toc-h-N` を見出しに付与
 */
export function initToc() {
  const containers = document.querySelectorAll(".bt_toc, .bt_toc_three-columns");
  containers.forEach((container) => {
    const selector = container.dataset.toc || "h2";
    const headings = Array.from(document.querySelectorAll(selector)).filter(
      (h) => !container.contains(h)
    );
    if (!headings.length) return;

    // 旧 Concrete エディタ起因で同じ id (`creek` 等) が複数の見出しに
    // 振られているケースがある (/guide/voice)。そのままだと TOC からの
    // ジャンプ先が常に最初の同名要素に固定されるため、JS 側で一意化する。
    const usedIds = new Set();
    const uniquify = (base) => {
      let candidate = base;
      let n = 2;
      while (usedIds.has(candidate)) candidate = `${base}-${n++}`;
      usedIds.add(candidate);
      return candidate;
    };

    const ul = document.createElement("ul");
    headings.forEach((h, idx) => {
      // anchor 解決 (優先順): 内側 <a id>/<a name> → 祖先 .q-wrap.id → h.id → 自動生成
      let baseId = "";
      let innerA = h.querySelector("a[id], a[name]");
      if (innerA) {
        baseId = innerA.id || innerA.getAttribute("name");
      } else {
        const qWrap = h.closest(".q-wrap");
        if (qWrap && qWrap.id) {
          baseId = qWrap.id;
        } else if (h.id) {
          baseId = h.id;
        } else {
          baseId = `toc-h-${idx + 1}`;
        }
      }
      const anchorId = uniquify(baseId);
      // 元の見出し (または内側 <a>) の id を一意化済みに揃え、リンク先と一致させる。
      if (innerA) {
        innerA.id = anchorId;
        innerA.removeAttribute("name");
      } else {
        h.id = anchorId;
      }

      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = `#${anchorId}`;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      ul.appendChild(li);
    });
    container.appendChild(ul);
  });
}
